import { render, staticRenderFns } from "./ImgJudge.vue?vue&type=template&id=11204dea&scoped=true"
import script from "./ImgJudge.vue?vue&type=script&lang=ts"
export * from "./ImgJudge.vue?vue&type=script&lang=ts"
import style0 from "./ImgJudge.vue?vue&type=style&index=0&id=11204dea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11204dea",
  null
  
)

export default component.exports